import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'place-center h-full w-full overflow-hidden bg-sage-2',
  card: 'py-12 px-16 shadow-none border border-grey-2',
  text: 'text-lg font-light',
};

export const styles = {
  card: {
    // Doing this in sx prevents a delay while Tailwind classes are still loading
    // @ts-ignore
    borderRadius: theme.shape.rounded['xl'],
    boxShadow: 'none',
    borderWidth: '1px',
    borderColor: theme.palette['grey-2'].main,
  },
};
